import React from 'react';
import Icon from '../../../components/AppIcon';

const CATEGORY_COLORS = {
  academic: 'from-blue-400 to-indigo-500',
  privilege: 'from-purple-400 to-pink-500',
  experience: 'from-green-400 to-teal-500',
  general: 'from-amber-400 to-orange-500',
};

const CATEGORY_BG = {
  academic: 'bg-blue-50 border-blue-100',
  privilege: 'bg-purple-50 border-purple-100',
  experience: 'bg-green-50 border-green-100',
  general: 'bg-amber-50 border-amber-100',
};

const RewardCard = ({ reward, availableStars, onRedeem }) => {
  const canAfford = availableStars >= (reward?.starCost || 0);
  const gradient = CATEGORY_COLORS?.[reward?.category] || CATEGORY_COLORS?.general;
  const bgClass = CATEGORY_BG?.[reward?.category] || CATEGORY_BG?.general;

  return (
    <div
      className={`rounded-2xl border-2 overflow-hidden transition-all duration-200 hover:shadow-lg hover:-translate-y-1 ${
        canAfford ? bgClass : 'bg-gray-50 border-gray-100 opacity-75'
      }`}
    >
      {/* Card Header */}
      <div className={`bg-gradient-to-br ${canAfford ? gradient : 'from-gray-300 to-gray-400'} p-5 flex items-center justify-center`}>
        <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center">
          <Icon name={reward?.icon || 'Gift'} size={32} className="text-white" />
        </div>
      </div>

      {/* Card Body */}
      <div className="p-4">
        <div className="mb-1">
          <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${
            canAfford ? 'bg-white/60 text-gray-600' : 'bg-gray-100 text-gray-400'
          }`}>
            {reward?.category || 'general'}
          </span>
        </div>
        <h3 className="font-bold text-foreground text-base mt-2 mb-1 line-clamp-1">
          {reward?.title}
        </h3>
        <p className="text-muted-foreground text-xs line-clamp-2 mb-4">
          {reward?.description || 'A special reward for your hard work!'}
        </p>

        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-1">
            <span className="text-lg">⭐</span>
            <span className={`font-bold text-lg ${canAfford ? 'text-amber-600' : 'text-gray-400'}`}>
              {reward?.starCost}
            </span>
            <span className="text-xs text-muted-foreground">stars</span>
          </div>
          <button
            onClick={() => canAfford && onRedeem(reward)}
            disabled={!canAfford}
            className={`px-3 py-1.5 rounded-lg text-sm font-semibold transition-all ${
              canAfford
                ? 'bg-amber-500 text-white hover:bg-amber-600 active:scale-95' :'bg-gray-200 text-gray-400 cursor-not-allowed'
            }`}
          >
            {canAfford ? 'Redeem' : 'Need more ⭐'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RewardCard;
